import React from 'react'
import PropTypes from 'prop-types'

import styles from './IconTable.css'

export const GLYPHS = [
    'avg-assist-damage',
    'avg-damage',
    'avg-exp',
    'avg-frags',
    'avg-survived',
    'battles-attack',
    'battles-with-steps',
    'battles',
    'damage-blocked',
    'days',
    'industrial',
    'league',
    'max-rank',
    'points',
    'rating',
    'role',
    'sbr',
    'sorties-absolute',
    'sorties-champion',
    'sorties-middle',
    'status',
    'wins',
]

const propTypes = {
    glyph: PropTypes.oneOf(GLYPHS).isRequired,
}

class IconTable extends React.PureComponent {
    render() {
        const classNameGlyph = styles[this.props.glyph]

        return (
            <div className={classNameGlyph} />
        )
    }
}

IconTable.propTypes = propTypes

export default IconTable



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/IconTable/IconTable.jsx